import * as React from 'react';
import {forwardRef, useEffect, useImperativeHandle, useState} from 'react';
import Formatter from '../../../util/formatter';
import {useTranslation} from 'react-i18next';
import useOpenState from '../../../hooks/useOpenState';
import {ColumnTypes} from './../hl7/hl7_messages_comp';
import ColumnsManager, {getColumns} from './../hl7/columns_manager';
import {useDispatch, useSelector} from 'react-redux';
import {agylePref} from '../../../store/reducers/preferences';
import _ from 'lodash';
import AttendancesTable from './attendances_table';
import {AttendanceAPI} from './attendances_api';
import {setLoading} from '../../../store/reducers/patient';
import MessageBox from '../../../util/messageBox';
import {setSnackbar} from '../../../store/reducers/globals';
import AgyleDialog from '../../../components/modal/agyleDialog';
import Grid from '@mui/material/Grid';
import AgyleTextField from '../../../components/ui/fields/agyleTextField';


const AttendancesComponent = forwardRef((props, ref) => {

    const {t} = useTranslation();
    const tableRef = React.useRef(null);
    const dispatch = useDispatch();
    const agylePreference = useSelector(agylePref);
    const [columns, setColumns] = React.useState([])
    const [isConfirmation, setConfiramtion] = React.useState(false)
    const [isAttMoveDialog, setAttMoveDialog] = React.useState(false)
    const [attMovePatientId, setattMovePatientId] = React.useState("")
    const [idToClose, setIdToClose] = React.useState("")
    const [patientId, setPatientId] = React.useState("")
    const [errorBox, setErrorBox] = React.useState(false)
    const [errorMessage, setErrorMessage] = React.useState("")

    const handleAcceptCloseAttendance = (message) => {
        setConfiramtion(false);
        AttendanceAPI.closeAttendance(idToClose).then(result => {
            dispatch(setSnackbar({type: 'success', message: t('Attendance have been closed')}));
        }).finally(() => {
            tableRef.current.refreshData();
        });
    }
    const closeAttendance = (message) => {
        setIdToClose(message._id["$oid"]);
        setConfiramtion(true);
    }

    const moveAttendance = (message) => {
        setIdToClose(message["attendanceId"]);
        setPatientId(message["patient_id"]);
        setAttMoveDialog(true);
    }
    const doMoveAttendace = () => {
        AttendanceAPI.moveAttendance(idToClose,patientId,attMovePatientId).then(result => {
            if(result.data.success) {
                dispatch(setSnackbar({type: 'success', message: t('Attendance have been moved')}));
            }else {
                setErrorMessage(result.data.message);
                setErrorBox(true)
            }
        }).catch(error => {
            console.log(error)
            dispatch(setSnackbar({type: 'error', message: t('Attendance move error')}));
        }).
        finally(() => {
            setAttMoveDialog(false);
            tableRef.current.refreshData();
        });
    }

    useEffect(()=>{
        setColumns(getColumns(columnsInit, agylePreference?.inMessageColumnOrder));
    },[agylePreference]);

    const columnsInit = [
        {
            name: 'id',
            order: 1,
            value: 'attendanceId',
            type: ColumnTypes.TEXT,
            description: 'ID',
            minWidth: 30
        },
        {
            name: 'mrn',
            order: 1,
            value: 'patient_id',
            type: ColumnTypes.TEXT,
            description: 'MRN No.',
            minWidth: 10,
            maxWidth: 175,
        },
        {
            name: 'patient',
            order: 1,
            value: 'patientDemographics',
            type: ColumnTypes.FUNC,
            getValue: (row) => {
                let pt = row.patient[0];
                return pt ? `${_.capitalize(pt?.firstName)} ${_.capitalize(pt?.familyName)}` : "-"
            },
            description: 'Patient Name',
            minWidth: 10,
            maxWidth: 175,
        },
        {
            name: 'admission',
            order: 1,
            value: 'startDate.$date',
            type: ColumnTypes.TEXT,
            description: 'Admission Date',
            minWidth: 10,
            maxWidth: 175,
            format: (value) => {
                return Formatter.utcAndLocalFormatData(value,"YYYY-MM-DD HH:mm:ss", "");
            }
        },
        {
            name: 'actions',
            order: 1,
            value: 'actions',
            type: ColumnTypes.ACTIONS,
            actionList: [
                {   callback: closeAttendance,
                    buttonLabel: "Close Attendance"
                },
                {   callback: moveAttendance,
                    buttonLabel: "Move Attendance"
                }
            ],
            description: 'Actions',
            minWidth: 10
        }

    ];

    const sortColumn = () => {
        const filteredColumns = _.filter(columns, col => {
            return !_.isNil(col.order);
        });

        return _.sortBy(filteredColumns, obj => {
            return obj.order;
        });
    };


    const [openConfig, setOpenConfig] = React.useState(false);

    return (<div>
        <AgyleDialog
            title={t('Move attendance to Patient')}
            open={isAttMoveDialog}
            onClose={() => {setAttMoveDialog(false)}}
            onSave={() => {
                doMoveAttendace();
            }}
            width="sm"
            fullWidth
        >
            <>
                <Grid item xs={12}>
                    <AgyleTextField
                        fullWidth
                        multiline
                        placeholder={t('New Patient Id')}
                        value={attMovePatientId}
                        onChange={(e) => setattMovePatientId(e.target.value)}
                        debounce
                    />
                </Grid>
            </>
        </AgyleDialog>
        <MessageBox
            open={isConfirmation}
            title={t('Confirm close attendance')}
            haveAccept={{yes: t('Submit'), no: t('Close')}}
            onAccept={handleAcceptCloseAttendance}
            onClose={() => {setConfiramtion(false)}}
            message={t('Are you sure you want to close attendance?')}
        />
        <MessageBox
            open={errorBox}
            title={t('Error moving ettendance')}
            haveAccept={{yes: t('Close')}}
            onAccept={() => {setErrorBox(false)}}
            onClose={() => {setErrorBox(false)}}
            message={errorMessage}
        />
        <ColumnsManager prefPath={"inMessageColumnOrder"}
                        columns = {columns}
                        title={"Incoming Messages Columns Settings"}
                        columnsInit = {columnsInit}
                        openConfig={openConfig}
                        closeModal={() => setOpenConfig(false)}/>

        <AttendancesTable ref={tableRef} table = {"hl7Log"} openColumnManager={() => setOpenConfig(true)} webSocketChanel = {"TODODocReports"} columns={sortColumn()} {...props}/>
    </div>);
})

export default AttendancesComponent;